import React, { useEffect } from 'react';
import { FormLayoutComposer, IFormLayoutProps } from 'components/common/form/renderer/FormLayoutComposer';
import { useQuery } from '@tanstack/react-query';
import { instance } from 'api/api';
import { APIResponse } from 'tools/types';

interface IExternalURLData {
    val: string;
    dynamic_parameter1_value: string;
}

export default function MetricDReportForm(props: IFormLayoutProps) {
    const reportId = props.hookForm.form.hookFormWatch('report_external_element_id');
    const metricId = props.hookForm.form.hookFormWatch('metric_element_id');

    const { data: externalURLData } = useQuery<IExternalURLData, Error>({
        queryKey: ['dReportGetExternalUrl', reportId, metricId],
        queryFn: async () => {
            const empty = { val: '', dynamic_parameter1_value: '' };
            if (metricId == '' || reportId == '' || metricId == 0 || reportId == 0) {
                return empty;
            }
            const response = await instance.get<APIResponse<IExternalURLData>>(
                `/data/editor/element/metric/${metricId}/d-report/${reportId}/get-external-url`,
            );
            return response.data.status == 'OK' ? response.data.data : empty;
        },
    });

    useEffect(() => {
        if (!externalURLData || externalURLData.val == '') {
            return;
        }
        props.hookForm.form.hookFormSetValue('external_report_url', externalURLData.val);
        props.hookForm.form.hookFormSetValue('dynamic_parameter1_value', externalURLData.dynamic_parameter1_value);
    }, [externalURLData]);

    return <FormLayoutComposer props={props} />;
}
